import { IncludedGuaranteesUI } from "./IncludedGuaranteesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function IncludedGuarantees({
  product,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant } = useVariant(product);
  const { services = [] } = variant;

  // const showOutletMessage = configProps?.showOutletMessage === true;

  const guarantees = services.filter(
    ({ __typename }) => __typename === "IncludedGuarantee",
  );

  return <IncludedGuaranteesUI guarantees={guarantees} />;
}
